import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ImpersonationMeta, User } from "@niko-crm/ui";


export const LoggedUserActions = createActionGroup({
  source: 'auth-login',
  events: {
    'Login Success': props<{
      user: User;
      permissions: string[];
      isSuperAdmin?: boolean;
      tenantName?: string;
      /** From `GET /users/me`; omitted/null outside an impersonation session. */
      impersonation?: ImpersonationMeta | null;
    }>(),
    'Select Tenant Success': props<{ tenantName: string }>(),
    'Set Logged User Data': emptyProps(),
    'Error Setting User Logged Data': props<{error:string }>(),
    'Logout Success': emptyProps(),
  },
});
